"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../utils/validations");
function updateQuizSessionsCompleted({ sessionsCompleted: existingSessionsCompleted }, session) {
    if (!(0, validations_1.isNumber)(existingSessionsCompleted)) {
        return 1;
    }
    return existingSessionsCompleted + 1;
}
exports.default = updateQuizSessionsCompleted;
